/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * All supported DID methods. Default is "web".
 */
export type DidCommMessageSignRequestDidMethod = 'key' | 'web';
export const DidCommMessageSignRequestDidMethod = {
    Key: 'key',
    Web: 'web',
} as const;
